/* src/app/modules/portal/components/lastDataSourceRefresh/lastDataSourceRefreshStatus/lastDataSourceRefreshStatus.component.css */
.item-group {
  margin-top: 0.8rem;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}
.item {
  display: flex;
  width: 50%;
  flex-direction: column;
}
.item[hideLastUpdate] {
  width: 100%;
}
/*# sourceMappingURL=lastDataSourceRefreshStatus.component.css.map */
